import { IDartsTour } from "../../Tournaments/TournamentsCRUD.types";

interface IProps {
    tournamentsIds: IDartsTour[];
    editMode: boolean;
    editTournament: IDartsTour | null;
    selectedWeek: string;
    selectedCompetition: number;
}

export const checkIsExistTournament = (props: IProps) => {
    const {
        tournamentsIds,
        editMode,
        editTournament,
        selectedWeek,
        selectedCompetition
    } = props;

    if (editMode && editTournament) {
        const filteredTournamentsIds = tournamentsIds.filter(
            (tour: { id: number; }) => tour.id !== editTournament.id
        );

        return filteredTournamentsIds.find(
            (tour) =>
                tour.week === selectedWeek &&
                tour.competitionId === selectedCompetition
        );
    } else {
        return Boolean(tournamentsIds.find(
            (tour) =>
                tour.week === selectedWeek &&
                tour.competitionId === selectedCompetition
        ));
    }
};
